import { TemplateRef } from '@angular/core';

export class UBXModal {
    template: TemplateRef<UBXModal>;
}
